module.exports = __webpack_public_path__ + "img/Wolfram_Alpha-Logo.859a6fc8.png";